import type { Security_SecurityAttributeSetting } from 'invApi';
import type { SecurityAttributeSetting } from '@invision/core';

/**
 * Convert API security attributes to core security attributes format
 *
 * The API returns Security_SecurityAttributeSetting with optional enum types,
 * while the core expects SecurityAttributeSetting with required number types.
 *
 * @param apiSecurityAttributes - Security attributes from API response
 * @returns Converted security attributes compatible with core functions
 */
export function convertApiSecurityAttributes(
  apiSecurityAttributes: Security_SecurityAttributeSetting[]
): SecurityAttributeSetting[] {
  return apiSecurityAttributes
    .filter((attr) => attr.Access !== undefined && attr.Attribute !== undefined)
    .map((attr) => ({
      Access: Number(attr.Access),
      Attribute: Number(attr.Attribute)
    }));
}

/**
 * Extract security attributes from session summary and convert to core format
 *
 * @param sessionSummary - Session summary from API response
 * @returns Converted security attributes ready for use with core functions
 */
export function extractSecurityAttributesFromSession(sessionSummary?: {
  AssignedSecurityAttributes?: Security_SecurityAttributeSetting[];
}): SecurityAttributeSetting[] {
  const apiSecurityAttributes =
    sessionSummary?.AssignedSecurityAttributes || [];
  return convertApiSecurityAttributes(apiSecurityAttributes);
}
